module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/soapBars_f18c3c.png";